import {
  DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT,DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT,DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT,

  DOCTEMPEDITOR_ON_START_GET_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES, DOCTEMPEDITOR_ON_GET_TEMPLATES,
  DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES, DOCTEMPEDITOR_ON_DELETE_TEMPLATES,
  DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE, DOCTEMPEDITOR_ON_LOAD_TEMPLATE,
  DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE,DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE,DOCTEMPEDITOR_ON_CREATE_TEMPLATE,
  DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE, DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE,
  DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES, DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES, DOCTEMPEDITOR_ON_UPDATE_TEMPLATES,
  DOCTEMPEDITOR_ON_START_ADD_PAGE, DOCTEMPEDITOR_ON_ERROR_ADD_PAGE, DOCTEMPEDITOR_ON_ADD_PAGE,
  DOCTEMPEDITOR_ON_START_UPDATE_PAGE, DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE, DOCTEMPEDITOR_ON_UPDATE_PAGE,
  DOCTEMPEDITOR_ON_START_DELETE_PAGE, DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE, DOCTEMPEDITOR_ON_DELETE_PAGE,
  DOCTEMPEDITOR_ON_START_ADD_SECTION, DOCTEMPEDITOR_ON_ERROR_ADD_SECTION, DOCTEMPEDITOR_ON_ADD_SECTION,
  DOCTEMPEDITOR_ON_START_UPDATE_SECTION, DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION, DOCTEMPEDITOR_ON_UPDATE_SECTION,
  DOCTEMPEDITOR_ON_START_DELETE_SECTION, DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION, DOCTEMPEDITOR_ON_DELETE_SECTION,
  DOCTEMPEDITOR_ON_START_UPDATE_COLUMN, DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN, DOCTEMPEDITOR_ON_UPDATE_COLUMN,
  DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE, DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE, DOCTEMPEDITOR_ON_CONVERT_TEMPLATE,
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT, DOCTEMPEDITOR_ON_LOAD_DOCUMENT,
  DOCTEMPEDITOR_ON_START_ACCEPT_OR_DECLINE_SENT_DOCUMENT,
  DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH,

	DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD,DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD,
	DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD, DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD,DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD,
  
  DOCTEMPEDITOR_ON_START_GET_DOCUMENTS, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS, DOCTEMPEDITOR_ON_GET_DOCUMENTS,
  DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS, DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS, DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS,
  DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS, DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS,
  DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE, DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE, DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE,
  DOCTEMPEDITOR_ON_START_SEND_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT, DOCTEMPEDITOR_ON_SEND_DOCUMENT,
  DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT, DOCTEMPEDITOR_ON_ATTEST_DOCUMENT,
  DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT, DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT,
  DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS, DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS,
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART,
  DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART,
  DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART, 
  DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART,
  DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART,
  DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART, 
  DOCTEMPEDITOR_ON_SET_CRESPONSE,
  DOCUMENT_EDITOR_ON_RESPOSE_RESET_EMPTY,

  DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP,
  DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP,
  DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP, 

  DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT,
  DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT,
  DOCTEMPEDITOR_ON_CREATE_DOCUMENT,
 DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL, 
 DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL, 
 DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL, 

  DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS,
  DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS,
  DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS,

  DOCTEMPEDITOR_ON_START_LOAD_META,
  DOCTEMPEDITOR_ON_LOAD_META,
  DOCTEMPEDITOR_ON_ERROR_LOAD_META,
  DOCTEMPEDITOR_ON_SET_GENERATING_BOOLEAN,
  DOCTEMPEDITOR_ON_RESET_CRESPONSE,
  //Jack
  ON_START_OFFERT_UPDATE_STATUS,ON_OFFERT_UPDATE_STATUS,ON_ERROR_OFFERT_UPDATE_STATUS,
  ON_OFFERT_UPDATE_STATUS_1,ON_OFFERT_UPDATE_STATUS_2,ON_OFFERT_UPDATE_STATUS_3,
  ON_OFFERT_UPDATE_STATUS_4,

  DOCTEMPEDITOR_ON_UNMOUNT_DOCUMENT_STATE

}  from '../constants/ActionTypes'
import {isUndefined,isEmpty, isNull} from 'lodash'
import { translate } from "../util/intlHelper";

const INIT_STATE = {
  Templates: [],
  TemplatesLoading: false,
  TemplateDynamicFields: [],
  TemplateDynamicFieldsLoading: false,
  PreTemplates: [],
  loading: false,
  loadingTemplate: false,
  loadingNewTemplate: false,
  response: null,
  cresponse: null,
  currentTemplate: null,
  convertingTempId: 0,

  currentDocument: null,
  currentDocumentAttach: [],
  currentDocumentSentStatus: null,
  shouldFetchDocumentSentStatus: true,

  Documents: [],
  DocumentsCount: 0,

  newDocumentsM: 0,
  passDeadlineM: 0,
  sellsArray: [],
  topProducts: [],
  LastSigns: [],
  EsignStatsObj: null,
  customFontColors: [],
  prepareDocument: false,
  SolelArtiklar:[],
  SchablonList: [],

  ReferensArtiklar: [],
  referensArtiklarLoading: false,
  
  metaLoading: false,
  metaResponse: null,
  generatingPDF: false
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

		case DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE :{
			return {
				...state,
				response: {loading: true, msg: translate("Action.Template.creating"), type: 'info'},
			}
		}
		case DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE: {
			return {
				...state,
				response: {loading: true, msg: translate("Action.Template.creating.error"), type: 'error'},
			}
		}
		case DOCTEMPEDITOR_ON_CREATE_TEMPLATE: {
			return {
				...state,
				response: {loading: true, msg: translate("Action.Template.creating.success"), type: 'success'},
			}
		}
    case DOCTEMPEDITOR_ON_UNMOUNT_DOCUMENT_STATE: {
      console.log("DOCTEMPEDITOR_ON_UNMOUNT_DOCUMENT_STATE", action.payload)
      return {
        ...state,
        currentDocument: null,
        currentTemplate: null,
        ReferensArtiklar: []
      }
    }
    case DOCTEMPEDITOR_ON_START_LOAD_META: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_META", action.payload)
      return {
        ...state,
        metaLoading: true,
        metaResponse: null
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_META: {
      console.log("DOCTEMPEDITOR_ON_LOAD_META", action.payload)
      return {
        ...state,
        metaLoading: false,
        metaResponse: {message: 'success', success: true}
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_META: {
      console.log("DOCTEMPEDITOR_ON_ERROR_LOAD_META", action.payload)
      return {
        ...state,
        metaLoading: false,
        metaResponse: {message: 'error', success: false}
      }
    }
    case DOCTEMPEDITOR_ON_START_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT", action.payload)
      return {
        ...state,
        // cresponse: action.payload,
        // loading: true,
        cresponse: {
          type: 'info',
          show: true,
          loading: true,
          success: true,
          msg: translate("Action.Sending.Document")
        }
      }
    }
    case DOCTEMPEDITOR_ON_START_ADD_PRODUCTS_FROM_EXCEL: {
      return {
        ...state,
        cresponse: {
          type: 'info',
          show: true,
          loading: true,
          success: true,
          msg: translate("Action.Import.Items")
        }
      }
    } 
    case DOCTEMPEDITOR_ON_ERROR_ADD_PRODUCTS_FROM_EXCEL: {
      return {
        ...state,
        loading: false,
        cresponse: {
          type: 'error',
          show: true,
          success: false,
          loading: false,
          msg: isUndefined(action.payload) ? translate("Error.Adding.item.fromExcel") : isUndefined(action.payload.error) ? translate("Error.Adding.item.fromExcel"): action.payload.error
        }
      }
    } 
    //Jack Here
    case DOCTEMPEDITOR_ON_ADD_PRODUCTS_FROM_EXCEL: {
      return {
        ...state,
        currentDocument: isEmpty(action.payload.Document) ? state.currentDocument: action.payload.Document,
        cresponse: {
          type: 'success',
          show: true,
          loading: false,
          success: true,
          msg: translate("Action.Articles.import")
        }
      }
    } 
  	case DOCTEMPEDITOR_ON_START_ATTEST_DOCUMENT:{
      return {
        ...state,
        cresponse: {
          type: 'info',
          show: true,
          loading: true,
          success: true,
          msg: translate("Action.Document.Attestsing")
        }
      }
		}
		case DOCTEMPEDITOR_ON_ERROR_ATTEST_DOCUMENT:{
      return {
        ...state,
        loading: false,
        cresponse: {
          type: 'error',
          show: true,
          success: false,
          loading: false,
          msg: isUndefined(action.payload) ? translate("Error.Documet.Attesting") : isUndefined(action.payload.error) ? translate("Error.Documet.Attesting") : action.payload.error
        }
      }
		}
		case DOCTEMPEDITOR_ON_ATTEST_DOCUMENT: {
      return {
        ...state,
        currentDocument: isEmpty(action.payload.Document) ? state.currentDocument: action.payload.Document,
        cresponse: {
          type: 'success',
          show: true,
          loading: false,
          success: true,
          msg: `${action.payload?.Document?.Type ?? translate("Document")} ${translate("Action.Document.Attest")}`
        }
      }
		}
    case DOCTEMPEDITOR_ON_SEND_DOCUMENT: {
      return {
        ...state,
        loading: false,
        currentDocument: isEmpty(action.payload.Document) ? state.currentDocument: action.payload.Document,
        currentTemplate: isEmpty(action.payload.Document) ? state.currentTemplate : null,
        shouldFetchDocumentSentStatus:true,
        cresponse: {
          type: 'success',
          show: true,
          loading: false,
          success: true,
          msg: translate("Action.Document.send")
        }
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_ERROR_SEND_DOCUMENT", action.payload)
      return {
        ...state,
        loading: false,
        cresponse: {
          type: 'error',
          show: true,
          success: false,
          loading: false,
          msg: isUndefined(action.payload) ? translate("Error.Document.send") : isUndefined(action.payload.error) ? translate("Error.Document.send") : action.payload.error
        }
      }
    }
     case DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_START_GET_MSG_SEND_DOCUMENT", action.payload)
      return {
        ...state
      }
    }
    case DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_GET_MSG_SEND_DOCUMENT", action.payload)
        return {
          ...state,
          currentDocumentSentStatus: {
            ...state.currentDocumentSentStatus,
            messages: action.payload.messages
          }
      }      
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_ERROR_GET_MSG_SEND_DOCUMENT", action.payload)
      return {
        ...state,
      }
    }
    //
    case DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_START_POST_MSG_SEND_DOCUMENT", action.payload)
      return {
        ...state
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_ERROR_POST_MSG_SEND_DOCUMENT", action.payload)
      return {
        ...state,
      }
    }
    case DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_POST_MSG_SEND_DOCUMENT", action.payload)
      return {
        ...state,
        currentDocumentSentStatus: {
          ...state.currentDocumentSentStatus,
          messages: action.payload.messages
        }
      }
    }
    
    case DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT", action.payload)
      return {
        ...state,
        // cresponse: action.payload,
        loading: true,
        generatingPDF: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT", action.payload)
      return {
        ...state,
        generatingPDF: false,
        loadingTemplate: false,
        loading: false,
        cresponse: {
          type: 'error',
          show: true,
          success: false,
          loading: false,
          msg: isUndefined(action.payload) ? translate("Error.Document.create") : isUndefined(action.payload.error) ?  translate("Error.Document.create") : action.payload.error
        }
      }
    }
    case DOCTEMPEDITOR_ON_CREATE_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_CREATE_DOCUMENT", action.payload)
      return {
        ...state,
        generatingPDF: false,
        loadingTemplate: false,
        currentDocument: action.payload.Document,
        currentTemplate: null,
        loading: false,
        cresponse: action.payload.EsignFlag === 1 ? null : {
          type: 'success',
          show: true,
          loading: false,
          success: true,
          msg: translate("Action.Document.created")
        }
      }
    }
    
    case DOCTEMPEDITOR_ON_START_GET_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_START_GET_TEMPLATES", action.payload)
      return {
        ...state,
        Templates: action.payload.init ? [] : state.Templates,
        TemplatesLoading: action.payload.init,
        PreTemplates: [],
        // loading: true,
        currentTemplate: null
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATES", action.payload)
      return {
        ...state,
        Templates: [],
        TemplatesLoading: false,
        PreTemplates: [],
        // loading: false
      }
    }
    case DOCTEMPEDITOR_ON_GET_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_GET_TEMPLATES", action.payload)
      return {
        ...state,
        Templates: action.payload.Templates,
        PreTemplates: action.payload.PreTemplates,
        TemplatesLoading: false,
        // loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_GET_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_START_GET_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: [],
        // DocumentsCount: 0,
        currentDocument: null,
        currentDocumentAttach: [],
        loading: true,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: [],
        DocumentsCount: 0,
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_GET_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_GET_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: action.payload.Documents,
        DocumentsCount: action.payload.Count,
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_START_SEARCH_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: [],
        DocumentsCount: 0,
        currentDocument: null,
        currentDocumentAttach: [],
        loading: true,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_ERROR_SEARCH_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: [],
        DocumentsCount: 0,
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS: {
      console.log("DOCTEMPEDITOR_ON_SEARCH_DOCUMENTS", action.payload)
      return {
        ...state,
        Documents: action.payload.Documents,
        DocumentsCount: action.payload.Count,
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_START_DELETE_TEMPLATES", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_RESET_CRESPONSE : {
      return {
        ...state,
        cresponse: null
      }
    }
    case DOCTEMPEDITOR_ON_SET_CRESPONSE : {
      return {
        ...state,
        metaLoading: false,
        cresponse: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATES", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Error.Document.delete")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_DELETE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_DELETE_TEMPLATES", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.delete")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE", action.payload)
      return {
        ...state,
        response: null,
        loading: true,
        loadingTemplate: true,
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_PRE_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE", action.payload)
      return {
        ...state,
        response: null,
        loading: false,
        loadingTemplate: false,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_PRE_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_PRE_TEMPLATE", action.payload)
      return {
        ...state,
        response: null,
        loading: false,
        loadingTemplate: false,
      }
    }
    case DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_TEMPLATE", action.payload)
      return {
        ...state,
        response: null,
        loading: true,
        loadingTemplate: true,
        loadingNewTemplate: true,
        currentTemplate: parseInt(action.payload.AttachFlag) === 0 ? null : state.currentTemplate,
        SchablonList:parseInt(action.payload.AttachFlag) === 0 ? [] : state.SchablonList
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_ERROR_LOAD_TEMPLATE", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        cresponse: {
          type: 'error',
          show: true,
          success: false,
          loading: false,
          msg: isUndefined(action.payload) ? translate("Error.Document.Load.Template") : isUndefined(action.payload.error) ? translate("Error.Document.Load.Template") : action.payload.error
        },
        loading: false,
        loadingTemplate: false,
        loadingNewTemplate: false,
        currentTemplate: null,
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_LOAD_TEMPLATE", action.payload)
      if(parseInt(action.payload.AttachFlag) === 0) {
        return {
          ...state,
          response: null,
          loading: false,
          loadingTemplate: false,
          loadingNewTemplate: false,
          currentTemplate: action.payload.Template,
          SchablonList: action.payload.SchablonList,
          //updateKalkyljson
          currentDocument: {
            ...state.currentDocument,
            ...(isUndefined(action.payload.Document) ? {} : action.payload.Document),
            KalkylJSON: action.payload.KalkylJSON,
          },
          prepareDocument: false,
        }
      } else if(parseInt(action.payload.AttachFlag) === 1 && !isNull(state.currentTemplate)) {
        let newPages = [...action.payload.Template.Pages]


        return {
          ...state,
          response: null,
          loading: false,
          loadingTemplate: false,
          prepareDocument: false,
          loadingNewTemplate: false,
          currentTemplate: {
            ...state.currentTemplate,
            Pages: newPages
          },
        }
      } else if(parseInt(action.payload.AttachFlag) === 1 && isNull(state.currentTemplate)) {
        let newPages = [...action.payload.Template.Pages]


        return {
          ...state,
          response: null,
          loading: false,
          loadingTemplate: false,
          loadingNewTemplate: false,
          currentDocument: {
            ...state.currentDocument,
            Pages: newPages
          },
        }
      }
    }

    case DOCTEMPEDITOR_ON_SET_GENERATING_BOOLEAN : {
      console.log("DOCTEMPEDITOR_ON_SET_GENERATING_BOOLEAN",action.payload)
      return {
        ...state,
        generatingPDF: true,
        cresponse: action.payload
      }
    }
    
    case DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT", action.payload)
      return {
        ...state,
        response: null,
        cresponse: null,
        loading: true,
        loadingTemplate: true,
        generatingPDF: false,
        prepareDocument: true,
        currentDocument: null,
        currentTemplate: null,
        currentDocumentAttach: [],
        currentDocumentSentStatus: null,
        generatingPDF: isUndefined(action.payload) ? state.generatingPDF : true,
        SchablonList: []
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT", action.payload)
      return {
        ...state,
        response: { success: false, message: isUndefined(action.payload) ? 'Error' : action.payload},
        loading: false,
        loadingTemplate: false,
        prepareDocument: false,
        currentDocument: null,
        currentTemplate: null,
        currentDocumentAttach: [],
        SchablonList: []
      }
    }
    case DOCTEMPEDITOR_ON_START_ACCEPT_OR_DECLINE_SENT_DOCUMENT : {
      console.log("DOCTEMPEDITOR_ON_START_ACCEPT_OR_DECLINE_SENT_DOCUMENT", action.payload)
      return {
        ...state,
        response: null,
        loading: true,
        loadingTemplate: true,
        prepareDocument: true,
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_DOCUMENT: {
      console.log("DOCTEMPEDITOR_ON_LOAD_DOCUMENT", action.payload)
      return {
        ...state,
        response: null,
        prepareDocument: false,
        generatingPDF: false,
        loading: action.payload.SaveFlag === 0 ? false : true,
        loadingTemplate: action.payload.SaveFlag === 0 ? false : true,
        currentDocument: action.payload.Document,
        currentDocumentSentStatus: isUndefined(action.payload.currentDocumentSentStatus) ? state.currentDocumentSentStatus : action.payload.currentDocumentSentStatus,
        SchablonList: action.payload.SchablonList,
      }
    }

    case DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_START_UPDATE_TEMPLATES", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_ERROR_UPDATE_TEMPLATES", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Error.Document.save.Template")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_UPDATE_TEMPLATES: {
      console.log("DOCTEMPEDITOR_ON_UPDATE_TEMPLATES", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_ADD_PAGE: {
      console.log("DOCTEMPEDITOR_ON_START_ADD_PAGE", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_ADD_PAGE: {
      console.log("DOCTEMPEDITOR_ON_ERROR_ADD_PAGE", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_ADD_PAGE: {
      console.log("DOCTEMPEDITOR_ON_ADD_PAGE", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_UPDATE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_START_UPDATE_PAGE", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_ERROR_UPDATE_PAGE", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_UPDATE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_UPDATE_PAGE", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_START_DELETE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_START_DELETE_PAGE", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_ERROR_DELETE_PAGE", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_DELETE_PAGE: {
      console.log("DOCTEMPEDITOR_ON_DELETE_PAGE", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.delete")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_ADD_SECTION: {
      console.log("DOCTEMPEDITOR_ON_START_ADD_SECTION", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_ADD_SECTION: {
      console.log("DOCTEMPEDITOR_ON_ERROR_ADD_SECTION", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_ADD_SECTION: {
      console.log("DOCTEMPEDITOR_ON_ADD_SECTION", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_UPDATE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_START_UPDATE_SECTION", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_ERROR_UPDATE_SECTION", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_UPDATE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_UPDATE_SECTION", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_START_DELETE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_START_DELETE_SECTION", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_ERROR_DELETE_SECTION", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_DELETE_SECTION: {
      console.log("DOCTEMPEDITOR_ON_DELETE_SECTION", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.delete")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_UPDATE_COLUMN: {
      console.log("DOCTEMPEDITOR_ON_START_UPDATE_COLUMN", action.payload)
      return {
        ...state,
        response: null,
        loading: true
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN: {
      console.log("DOCTEMPEDITOR_ON_ERROR_UPDATE_COLUMN", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Error.Document.save.Template")},
        loading: false
      }
    }
    case DOCTEMPEDITOR_ON_UPDATE_COLUMN: {
      console.log("DOCTEMPEDITOR_ON_UPDATE_COLUMN", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Save")},
        loading: false
      }
    }

    case DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_START_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        response: null,
        loading: true,
        convertingTempId: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_ERROR_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        loading: false,
        convertingTempId: 0
      }
    }
    case DOCTEMPEDITOR_ON_CONVERT_TEMPLATE: {
      console.log("DOCTEMPEDITOR_ON_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Convert")},
        loading: false,
        convertingTempId: 0
      }
    }
    case DOCTEMPEDITOR_ON_START_GET_DOCUMENT_STATS : {
      console.log("DOCTEMPEDITOR_ON_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        newDocumentsM: 0,
        passDeadlineM: 0,
        sellsArray: [],
        topProducts: [],
        LastSigns: [],
        EsignStatsObj: null
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_STATS : {
      console.log("DOCTEMPEDITOR_ON_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        newDocumentsM: 0,
        passDeadlineM: 0,
        sellsArray: [],
        topProducts: [],
        LastSigns: [],
        EsignStatsObj: null
      }
    }
    case DOCTEMPEDITOR_ON_GET_DOCUMENT_STATS : {
      console.log("DOCTEMPEDITOR_ON_CONVERT_TEMPLATE", action.payload)
      return {
        ...state,
        newDocumentsM: action.payload.newDocumentsM,
        passDeadlineM: action.payload.passDeadlineM,
        sellsArray: action.payload.sellsArray,
        topProducts: action.payload.topProducts,
        LastSigns: action.payload.LastSigns,
        EsignStatsObj: action.payload.EsignStatsObj,
      }
    }
    case DOCTEMPEDITOR_ON_START_SEND_DOCUMENT : {
      console.log("DOCTEMPEDITOR_ON_START_SEND_DOCUMENT", action.payload)
      return {
        ...state,
        shouldFetchDocumentSentStatus: true
        // currentDocumentSentStatus: []
      }
    }
    case DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE : {
      console.log("DOCTEMPEDITOR_ON_START_GET_DOCUMENT_SENT_TIMELINE", action.payload)
      return {
        ...state,
        // currentDocumentSentStatus: []
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE : {
      console.log("DOCTEMPEDITOR_ON_ERROR_GET_DOCUMENT_SENT_TIMELINE", action.payload)
      return {
        ...state,
        currentDocumentSentStatus: null
      }
    }
    case DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE : {
      console.log("DOCTEMPEDITOR_ON_GET_DOCUMENT_SENT_TIMELINE", action.payload)

      const {mottagarArr} = action.payload

      let shouldFetch = false

      if(!isEmpty(mottagarArr)) {
        for (let m of mottagarArr) {
          if(m.Timeline[m.Timeline.length - 1].status <= 2 || m.Timeline[m.Timeline.length - 1].status == 8) shouldFetch = true
        }
      }

      return {
        ...state,
        currentDocumentSentStatus: action.payload,
        shouldFetchDocumentSentStatus: shouldFetch
      }
    }
    case DOCTEMPEDITOR_ON_GET_DOCUMENT_ATTACH: {
      return {
        ...state, 
        currentDocumentAttach: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_START_GET_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        loading: true,
        response: null,
        customFontColors: []
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_ERROR_GET_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: false, message: translate("Action.Document.error")},
        loading: false,
        customFontColors: []
      }
    }
    case DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_GET_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: true, message: translate("Action.Document.Success")},
        loading: false,
        customFontColors: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_START_ADD_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        loading: true,
        response: null,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_ERROR_ADD_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: false, message: translate("Action.Document.error")},
        loading: false,
      }
    }
    case DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_ADD_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: true, message: translate("Action.Document.Success")},
        loading: false,
      }
    }
    case DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_START_REMOVE_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        loading: true,
        response: null,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_ERROR_REMOVE_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: false, message: translate("Action.Document.error")},
        loading: false,
      }
    }
    case DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS: {
      console.log("DOCTEMPEDITOR_ON_REMOVE_CUSTOM_FONT_COLORS", action.payload)
      return {
        ...state, 
        response: { success: true, message: translate("Action.Document.Success")},
        loading: false,
      }
    }
    case DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART: {
      console.log('DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_SOLEL_ART', action.payload)
      return {
        ...state,
        response: null,
        SolelArtiklar: []
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART: {
      console.log('DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_SOLEL_ART', action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        SolelArtiklar: []
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART: {
      console.log('DOCTEMPEDITOR_ON_LOAD_DOCUMENT_SOLEL_ART', action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Success")},
        SolelArtiklar: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART: {
      console.log('DOCTEMPEDITOR_ON_START_LOAD_DOCUMENT_REFERENS_ART', action.payload)
      return {
        ...state,
        response: null,
        ReferensArtiklar: [],
        ReferensArtiklarLoading: true,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART: {
      console.log('DOCTEMPEDITOR_ON_ERROR_LOAD_DOCUMENT_REFERENS_ART', action.payload)
      return {
        ...state,
        response: { success: false, message: translate("Action.Document.error")},
        ReferensArtiklar: [],
        ReferensArtiklarLoading: false,
      }
    }
    case DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART: {
      console.log('DOCTEMPEDITOR_ON_LOAD_DOCUMENT_REFERENS_ART', action.payload)
      return {
        ...state,
        response: { success: true, message: translate("Action.Document.Success")},
        ReferensArtiklar: action.payload,
        ReferensArtiklarLoading: false,
      }
    }
    case DOCTEMPEDITOR_ON_START_CREATE_DOCUMENT_FROM_TEMP: {
      return {
        ...state,
        loading: true,
        response: null,
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_CREATE_DOCUMENT_FROM_TEMP: {
      return {
        ...state,
        loading: false,
        response: { success: false, message: translate("Action.Document.error")},
      }
    }
    case DOCTEMPEDITOR_ON_CREATE_DOCUMENT_FROM_TEMP: {
      return {
        ...state,
        loading: false,
        response: { success: true, message: translate("Action.Document.Success")},
      }
    }
    case DOCTEMPEDITOR_ON_START_GET_PROSPECT_DOCS: {
      return {
        ...state,
        DocsFromProspect: []
      }
    }
    case DOCTEMPEDITOR_ON_GET_PROSPECT_DOCS: {
      return {
        ...state,
        DocsFromProspect: action.payload
      }
    }
    case DOCTEMPEDITOR_ON_ERROR_GET_PROSPECT_DOCS: {
      return {
        ...state,
        DocsFromProspect: []
      }
    }

		case DOCTEMPEDITOR_ON_START_GET_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: true,
        response: null
			}
		}
		case DOCTEMPEDITOR_ON_ERROR_GET_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: false,
        response: { msg: translate("Error.Document"), type: 'error', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_GET_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: action.payload.TemplateDynamicFields,
				TemplateDynamicFieldsLoading: false,
        response: null
			}
		}
		case DOCTEMPEDITOR_ON_START_DELETE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: true,
        response: { msg: 'Tar bort fält', type: 'error', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_ERROR_DELETE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: false,
        response: { msg: translate("Error.Document"), type: 'error', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_DELETE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: action.payload.TemplateDynamicFields,
				TemplateDynamicFieldsLoading: false,
        response: { msg: translate("Action.Document.delete"), type: 'warning', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_START_EDIT_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: true,
        response: { msg: translate("Action.Document.saving"), type: 'info', loading: true},
			}
		}
		case DOCTEMPEDITOR_ON_ERROR_EDIT_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: false,
        response: { msg: translate("Error.Document"), type: 'error', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_EDIT_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: action.payload.TemplateDynamicFields,
				TemplateDynamicFieldsLoading: false,
        response: {msg: translate("Action.Document.save"), type: 'success', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_START_CREATE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: true,
        response: {msg: translate("Action.Document.creating.Field"), type: 'info', loading: true},
			}
		}
		case DOCTEMPEDITOR_ON_ERROR_CREATE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: [],
				TemplateDynamicFieldsLoading: false,
        response: { msg: translate("Error.Document"), type: 'error', loading: false},
			}
		}
		case DOCTEMPEDITOR_ON_CREATE_TEMPLATE_DYNAMIC_FIELD: {
			return {
				...state,
				TemplateDynamicFields: action.payload.TemplateDynamicFields,
				TemplateDynamicFieldsLoading: false,
        response: {msg: translate("Action.Document.create"), type: 'success', loading: false},
			}
		}

    //ON_START_OFFERT_UPDATE_STATUS,ON_OFFERT_UPDATE_STATUS,ON_ERROR_OFFERT_UPDATE_STATUS,
    case ON_START_OFFERT_UPDATE_STATUS: {
      return {
        ...state,
        response: null,
      }
    }
    case DOCUMENT_EDITOR_ON_RESPOSE_RESET_EMPTY: {
      return {
        ...state,
        response: null,
      }
    }
    case ON_OFFERT_UPDATE_STATUS: {
      console.log("ON_OFFERT_UPDATE_STATUS",action)      
      let Documentss = state.Documents
      let Documentd1 = Documentss.filter(item=>{
        return  parseInt(item.id) === parseInt(action.payload.OffertId) && parseInt(item.OldDocument) === 0
      })[0]
      let indexf = Documentss.indexOf(Documentd1)
      if(parseInt(indexf) !== -1){
        let Documentd = {
          ...Documentd1,
          Status:action.payload.newStatus
        }
        Documentss[indexf] = Documentd
      }
      /**/
      return {
        ...state,
        Documents: Documentss,
        response: { success: false, message: action.payload.message},
      }
    }
    case ON_OFFERT_UPDATE_STATUS_1:{
      console.log("ON_OFFERT_UPDATE_STATUS",action)      
      let Documentss = state.Documents
      let Documentd1 = Documentss.filter(item=>{
        return  parseInt(item.id) === parseInt(action.payload.OffertId) && parseInt(item.OldDocument) === 1 && parseInt(item.Offertnr) === 0
      })[0]
      let indexf = Documentss.indexOf(Documentd1)
      if(parseInt(indexf) !== -1){
        let Documentd = {
          ...Documentd1,
          Status:action.payload.newStatus
        }
        Documentss[indexf] = Documentd
      }
      /**/
      return {
        ...state,
        Documents: Documentss,
        response: { success: false, message: action.payload.message},
      }
    }
    case ON_OFFERT_UPDATE_STATUS_2:{
      console.log("ON_OFFERT_UPDATE_STATUS_2",action)      
      let Documentss = state.Documents
      let Documentd1 = Documentss.filter(item=>{
        return  parseInt(item.id) === parseInt(action.payload.OffertId) && parseInt(item.OldDocument) === 1 && parseInt(item.Offertnr) !== 0
      })[0]
      let indexf = Documentss.indexOf(Documentd1)
      if(parseInt(indexf) !== -1){
        let Documentd = {
          ...Documentd1,
          Status:action.payload.newStatus
        }
        Documentss[indexf] = Documentd
      }
      /**/
      return {
        ...state,
        Documents: Documentss,
        response: { success: false, message: action.payload.message},
      }
    }
    case ON_OFFERT_UPDATE_STATUS_3:{
      console.log("ON_OFFERT_UPDATE_STATUS_3",action)      
      let Documentss = state.Documents
      let Documentd1 = Documentss.filter(item=>{
        return  parseInt(item.id) === parseInt(action.payload.OffertId) && parseInt(item.OldDocument) === 2
      })[0]
      let indexf = Documentss.indexOf(Documentd1)
      if(parseInt(indexf) !== -1){
        let Documentd = {
          ...Documentd1,
          Status:action.payload.newStatus
        }
        Documentss[indexf] = Documentd
      }
      /**/
      return {
        ...state,
        Documents: Documentss,
        response: { success: false, message: action.payload.message},
      }
    }
    case ON_OFFERT_UPDATE_STATUS_4:{
      console.log("ON_OFFERT_UPDATE_STATUS_4",action)      
      let Documentss = state.Documents
      let Documentd1 = Documentss.filter(item=>{
        return  parseInt(item.id) === parseInt(action.payload.OffertId) && parseInt(item.OldDocument) === 6
      })[0]
      let indexf = Documentss.indexOf(Documentd1)
      if(parseInt(indexf) !== -1){
        let Documentd = {
          ...Documentd1,
          Status:action.payload.newStatus
        }
        Documentss[indexf] = Documentd
      }
      /**/
      return {
        ...state,
        Documents: Documentss,
        response: { success: false, message: action.payload.message},
      }
    }
    case ON_ERROR_OFFERT_UPDATE_STATUS: {
      return {
        ...state,
        loading: false,
        response: { success: false, message: translate("Action.Document.error")},
      }
    }
    // Documents: action.payload.Documents,
    default: {
      return state
    }
  }
}
